export default __webpack_public_path__ + "static/media/price-low.0e3650be.svg";